<style scoped lang="scss">
.dealer-list-page {
  .filter-card,
  .table-card {
    margin-bottom: 16px;
    border-radius: 4px;
  }
  .filter-card ::v-deep .el-card__body {
    padding: 16px 20px 12px;
  }
  .table-card ::v-deep .el-card__body {
    padding: 0 0 16px;
  }
  .filter-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px 12px;
    .filter-item {
      width: 160px;
    }
    .filter-item--wide {
      width: 200px;
    }
    .filter-search-btn {
      margin-left: 4px;
    }
  }
  .toolbar-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid #ebeef5;
  }
  .pagination-wrap {
    padding: 16px 20px 0;
    text-align: right;
  }
}
.store-name {
  padding-bottom: 4px;
  font-size: 15px;
  font-weight: 500;
  color: #303133;
  line-height: 1.4;
}
.store-contact {
  color: #909399;
  font-size: 13px;
  line-height: 1.6;
  span {
    margin-right: 12px;
  }
}
.store-contact-line {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.store-address {
  color: #909399;
}
.fq-pay-tags {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 6px;
  width: 100%;
  text-align: left;
  .el-tag {
    margin: 0;
  }
  .fq-pay-empty {
    color: #c0c4cc;
    font-size: 13px;
  }
}
.table-card ::v-deep td.fq-pay-col .cell {
  text-align: left;
}
.action-cell {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 0;
  .action-link {
    display: inline-block;
    padding: 0 8px;
    line-height: 28px;
    font-size: 13px;
    color: #409eff;
    text-decoration: none;
    white-space: nowrap;
    &:hover {
      color: #66b1ff;
    }
  }
  .action-divider {
    display: inline-block;
    width: 1px;
    height: 14px;
    margin: 0 2px;
    background: #dcdfe6;
    vertical-align: middle;
  }
  ::v-deep .el-link {
    font-size: 13px;
    padding: 0 8px;
  }
}
.tip_style {
  color: #ff5000;
}
</style>
<template>
  <div>
    <div
      v-if="
        $route.path.indexOf('_editor') === -1 &&
        $route.path.indexOf('_detail') === -1 &&
        $route.path.indexOf('_template') === -1
      "
    >
      <div class="dealer-list-page">
      <el-card class="filter-card" shadow="never">
        <div class="filter-row">
          <el-select
            class="filter-item"
            v-model="params.is_valid"
            @change="isValidSelectHandle"
            placeholder="是否启用"
            clearable
          >
            <el-option
              v-for="(item, index) in isValidList"
              :key="index"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-input
            class="filter-item filter-item--wide"
            placeholder="经销商名称"
            v-model="params.name"
            clearable
            @keyup.enter.native="numberSearch"
            @clear="numberSearch"
          ></el-input>
          <el-input
            class="filter-item"
            placeholder="经销商 HQID"
            v-model="params.dealer_hqid"
            clearable
            @keyup.enter.native="numberSearch"
            @clear="numberSearch"
          ></el-input>
          <el-input
            class="filter-item"
            placeholder="分销商 HQID"
            v-model="params.distributor_hqid"
            clearable
            @keyup.enter.native="numberSearch"
            @clear="numberSearch"
          ></el-input>
          <el-input
            class="filter-item"
            placeholder="分销商 VAD"
            v-model="params.distributor_vad"
            clearable
            @keyup.enter.native="numberSearch"
            @clear="numberSearch"
          ></el-input>
          <el-input
            class="filter-item"
            placeholder="渠道 RTM"
            v-model="params.channel_rtm"
            clearable
            @keyup.enter.native="numberSearch"
            @clear="numberSearch"
          ></el-input>
          <el-select
            v-if="login_type != 'admin'"
            class="filter-item"
            v-model="params.payment_channel"
            @change="paymentChannelSelectHandle"
            placeholder="支付通道"
            clearable
          >
            <el-option
              v-for="(item, index) in paymentChannelList"
              :key="index"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-button
            icon="el-icon-search"
            type="primary"
            class="filter-search-btn"
            @click="numberSearch"
          >搜索</el-button>
        </div>
        <div v-if="operator_type != 'admin'" class="toolbar-row">
          <el-button
            v-if="!is_distributor && !distributor_self && login_type !== 'dealer'"
            type="primary"
            icon="el-icon-plus"
            @click="addDistributorSelf()"
          >新增经销商</el-button>
          <ImportDialog
            v-if="operator_type == 'admin_del' || operator_type == 'staff' || operator_type == 'disti'"
            buttonName="导入经销商"
            buttonSize="default"
            fileName="导入经销商"
            fileType="upload_dealer"
          ></ImportDialog>
          <el-button type="primary" plain icon="el-icon-download" :loading="exportloading" @click="exportData">导出</el-button>
          <el-tooltip content="导出任务会以队列执行，请到「设置 - 导出列表」查看及下载" placement="top">
            <i class="el-icon-question" style="color: #909399; cursor: help;"></i>
          </el-tooltip>
        </div>
      </el-card>
      <el-card class="table-card" shadow="never">
        <el-table
          :data="list"
          @selection-change="handleSelectionChange"
          v-loading="loading"
          stripe
          border
          style="width: 100%"
        >
          <el-table-column
            type="selection"
            width="48"
            align="center"
          ></el-table-column>
          <el-table-column label="经销商信息" min-width="168" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="store-name store-contact-line" :title="scope.row.name">{{ scope.row.name }}</div>
              <div class="store-contact store-contact-line">
                <span>ID：{{ scope.row.dealer_id }}</span>
                <span v-if="scope.row.dealer_hqid">
                  <i class="el-icon-s-shop"></i>
                  {{ scope.row.dealer_hqid }}
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="分销商信息" width="148" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="store-contact store-contact-line" :title="scope.row.distributor_hqid">HQID：{{ scope.row.distributor_hqid || '—' }}</div>
              <div class="store-contact store-contact-line" :title="scope.row.distributor_vad">VAD：{{ scope.row.distributor_vad || '—' }}</div>
              <div class="store-contact store-contact-line" :title="scope.row.channel_rtm">RTM：{{ scope.row.channel_rtm || '—' }}</div>
            </template>
          </el-table-column>
          <el-table-column width="72" label="状态" align="center" v-if="login_type !== 'dealer' && login_type !== 'admin'">
            <template slot-scope="scope">
              <el-switch
                v-if="scope.row.is_valid !== 'delete'"
                :value="scope.row.is_valid === 'true'"
                :disabled="validSwitchLoading === scope.row.dealer_id"
                active-color="#13ce66"
                inactive-color="#dcdfe6"
                @change="(checked) => onValidSwitchChange(scope.row, checked)"
              />
              <span v-else class="muted">废弃</span>
            </template>
          </el-table-column>
          <el-table-column label="小程序码" width="88" align="center" v-if="login_type !== 'dealer'">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="downQrCode('online', scope.row)">线上</el-button>
            </template>
          </el-table-column>
          <el-table-column label="分期支持" width="132" align="left" class-name="fq-pay-col">
            <template slot-scope="scope">
              <div class="fq-pay-tags">
                <el-tag v-if="scope.row.open_fq_pay_hua_bei == '1'" type="primary" size="mini" effect="plain">花呗分期</el-tag>
                <el-tag v-if="scope.row.open_fq_pay_credit_card == '1'" type="primary" size="mini" effect="plain">信用卡分期</el-tag>
                <span
                  v-if="scope.row.open_fq_pay_hua_bei != '1' && scope.row.open_fq_pay_credit_card != '1'"
                  class="fq-pay-empty"
                >—</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="支付通道" width="88" align="center" v-if="login_type != 'admin'">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.payment_channel === 'dougong'" type="success" size="mini">斗拱</el-tag>
              <el-tag v-else size="mini" type="info">AdaPay</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="400" align="left">
            <template slot-scope="scope">
              <div class="action-cell">
                <router-link
                  v-if="login_type !== 'dealer' && login_type != 'admin' && scope.row.is_valid !== 'delete'"
                  class="action-link"
                  :to="{
                    path: matchHidePage('editor'),
                    query: { dealer_id: scope.row.dealer_id },
                  }"
                >编辑</router-link>
                <template v-if="login_type !== 'dealer' && login_type != 'admin' && scope.row.is_valid !== 'delete'">
                  <span class="action-divider"></span>
                </template>
                <el-link
                  v-if="login_type != 'admin'"
                  type="primary"
                  :underline="false"
                  @click="openPaymentChannelConfig(scope.row)"
                >支付通道</el-link>
                <template v-if="login_type != 'admin'">
                  <span class="action-divider"></span>
                  <el-link type="primary" :underline="false" @click="openSplitConfig(scope.row)">分账配置</el-link>
                  <span class="action-divider"></span>
                  <el-link type="primary" :underline="false" @click="getAdapaySetting(scope.row)">AdaPay配置</el-link>
                  <span class="action-divider"></span>
                  <el-link type="primary" :underline="false" @click="openDougongSetting(scope.row)">斗拱配置</el-link>
                  <span class="action-divider"></span>
                </template>
                <el-link type="primary" :underline="false" @click="handleStagingConfig(scope.row)">分期配置</el-link>
                <template v-if="login_type === 'dealer'">
                  <span class="action-divider"></span>
                  <el-link type="primary" :underline="false" @click="getAdaPayCashSetting(scope.row)">提现</el-link>
                </template>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-wrap">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="params.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="params.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total_count"
          ></el-pagination>
        </div>
      </el-card>
      </div>
    </div>
    <router-view></router-view>
    <el-drawer
      :title="title"
      :visible.sync="dialog"
      direction="rtl"
      custom-class="demo-drawer"
      ref="drawer"
      size="50%"
    >
      <div class="demo-drawer__content">
        <el-tabs type="border-card">
          <el-tab-pane>
            <span slot="label"><i class="el-icon-postcard"></i> 线下业务</span>
            <el-form ref="adapayForm" :model="adapayForm" label-width="200px" :rules="rules">
<!--              <el-form-item label="名称(商城系统)" prop='name'>-->
<!--                <span class="frm-tips">{{adapayForm.name}}</span>-->
<!--              </el-form-item>-->
              <el-form-item label="名称(支付拉取)" prop='mer_name' v-if="adapayForm.mer_name ">
                <span class="frm-tips">{{adapayForm.mer_name}}</span>
                <div>
                  <span class="red frm-tips">* 请检查商户号拉取的商户名称！</span>
                </div>
              </el-form-item>

              <el-form-item label="AdaPay APP ID" prop='app_id'>
                <el-input :disabled="adapayFormRes.app_id" v-model="adapayForm.app_id" style="width:450px"/>
                <br/>
                <span class="frm-tips">汇付商户后台调用支付的应用ID</span>
              </el-form-item>
              <el-form-item label="AdaPay APP KEY" prop='api_key_live'>
                <el-input :disabled="adapayFormRes.api_key_live" v-model="adapayForm.api_key_live" style="width:450px"/>
                <br/>
                <span class="frm-tips">prod 环境下交易密钥</span>
              </el-form-item>
              <el-form-item label="商户 PRIVATE KEY(RSA)" prop='rsa_private_key'>
                <el-input :disabled="adapayFormRes.rsa_private_key"
                          type="textarea"
                          :rows="18"
                          placeholder="请输入内容"
                          style="width:450px"
                          maxlength="1500"
                          show-word-limit
                          v-model="adapayForm.rsa_private_key"
                />
                <br/>
                <p class="frm-tips" style="margin-left:0px">用于商户发起交易接口请求时, AdaPay 对请求对象进行 RSA 加密验签使用</p>
              </el-form-item>
              <el-form-item label="AdaPay PUBLIC KEY(RSA)" prop='rsa_public_key'>
                <el-input :disabled="adapayFormRes.rsa_public_key"
                          type="textarea"
                          :rows="6"
                          maxlength="500"
                          placeholder="请输入内容"
                          style="width:450px"
                          show-word-limit
                          v-model="adapayForm.rsa_public_key"
                />
                <br/>
                <span class="frm-tips">用于 AdaPay 异步回调时，商户 Server 验证请求对象的正确性</span>
              </el-form-item>
              <div class="section-footer">
                <el-form-item>
                  <div>
                    <span v-if="adapayForm.mer_name " class="red frm-tips">* 请检查商户号拉取的商户名称,确认无误后保存</span>
                  </div>
                  <el-button type="primary" v-loading="loading" @click="onSubmitFrom('adapayForm')">保存</el-button>
                </el-form-item>
              </div>
            </el-form>
          </el-tab-pane>

          <el-tab-pane>
            <span slot="label"><i class="el-icon-s-platform"></i> 线上业务</span>
            <el-form ref="adapayFormOnline" :model="adapayFormOnline" label-width="200px" :rules="rules">
<!--              <el-form-item label="名称(商城系统)" prop='name'>-->
<!--                <span class="frm-tips">{{adapayForm.name}}</span>-->
<!--              </el-form-item>-->
              <el-form-item label="名称(支付拉取)" prop='mer_name' v-if="adapayFormOnline.mer_name ">
                <span class="frm-tips">{{adapayFormOnline.mer_name}}</span>
                <div>
                  <span class="red frm-tips">* 请检查商户号拉取的商户名称！</span>
                </div>
              </el-form-item>

              <el-form-item label="AdaPay APP ID" prop='app_id'>
                <el-input :disabled="adapayFormResOnline.app_id" v-model="adapayFormOnline.app_id" style="width:450px"/>
                <br/>
                <span class="frm-tips">汇付商户后台调用支付的应用ID</span>
              </el-form-item>
              <el-form-item label="AdaPay APP KEY" prop='api_key_live'>
                <el-input :disabled="adapayFormResOnline.api_key_live" v-model="adapayFormOnline.api_key_live" style="width:450px"/>
                <br/>
                <span class="frm-tips">prod 环境下交易密钥</span>
              </el-form-item>
              <el-form-item label="商户 PRIVATE KEY(RSA)" prop='rsa_private_key'>
                <el-input :disabled="adapayFormResOnline.rsa_private_key"
                          type="textarea"
                          :rows="18"
                          placeholder="请输入内容"
                          style="width:450px"
                          maxlength="1500"
                          show-word-limit
                          v-model="adapayFormOnline.rsa_private_key"
                />
                <br/>
                <p class="frm-tips" style="margin-left:0px">用于商户发起交易接口请求时, AdaPay 对请求对象进行 RSA 加密验签使用</p>
              </el-form-item>
              <el-form-item label="AdaPay PUBLIC KEY(RSA)" prop='rsa_public_key'>
                <el-input :disabled="adapayFormResOnline.rsa_public_key"
                          type="textarea"
                          :rows="6"
                          maxlength="500"
                          placeholder="请输入内容"
                          style="width:450px"
                          show-word-limit
                          v-model="adapayFormOnline.rsa_public_key"
                />
                <br/>
                <span class="frm-tips">用于 AdaPay 异步回调时，商户 Server 验证请求对象的正确性</span>
              </el-form-item>
              <div class="section-footer">
                <el-form-item>
                  <div>
                    <span v-if="adapayFormOnline.mer_name " class="red frm-tips">* 请检查商户号拉取的商户名称,确认无误后保存</span>
                  </div>
                  <el-button type="primary" v-loading="loading" @click="onSubmitFrom('adapayFormOnline',0,'online')">保存</el-button>
                </el-form-item>
              </div>
            </el-form>
          </el-tab-pane>


        </el-tabs>
      </div>
    </el-drawer>
    <el-drawer
      :title="cashTitle"
      :visible.sync="cashDialog"
      direction="rtl"
      custom-class="demo-drawer"
      ref="drawer"
      size="50%"
    >
      <div class="demo-drawer__content">
        <el-form ref="adapayForm" :model="adapayForm" label-width="200px" :rules="rules">

          <el-form-item style="display: none" label="账户应用ID">
            <span>{{ adapayForm.app_id }}</span>
          </el-form-item>

          <el-form-item label="可提现余额">
            <span>{{ adapayForm.acct_balance || '0.00' }} 元</span>
          </el-form-item>

          <el-form-item style="display: none" label="是否自动">
            <el-switch v-model="adapayForm.auto_cash" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
          </el-form-item>
          <el-form-item label="提现类型">
            <el-radio-group v-model="adapayForm.cash_type">
              <!--              <el-radio :label="'D0'">即时取现</el-radio>-->
              <!--              <el-radio :label="'D1'">D+1取现</el-radio>-->
              <el-radio :label="'T1'">T+1取现</el-radio>
            </el-radio-group>
          </el-form-item>
<!--          <el-form-item label="预留金">-->
<!--            <span>{{ adapayForm.remained_amt || '0.00' }} 元</span>-->
<!--            &lt;!&ndash;            <el-input-number v-model="adapayForm.remained_amt" controls-position="right" :precision="2" :min="0" @change="handleChange" :disabled="inputDisabled"></el-input-number>&ndash;&gt;-->
<!--          </el-form-item>-->
          <el-form-item label="提现金额">
            <div>
              <el-col :span="10">
                <el-input  v-model="amount" :placeholder=" '最大输入金额不得超过'+(adapayForm.acct_balance || '0.00') "></el-input>
                <span  class="tip_style ">不填金额则默认为全部提现</span>
                <!--                <el-input v-model="amount  ":placeholder="`最大输入金额不得超过${adapayForm.remained_amt || '0.00'}`"></el-input>-->
              </el-col>
            </div>
          </el-form-item>
          <div class="section-footer">
            <el-form-item>
              <el-button  v-if="doCash === true" type="primary" v-loading="loading" plain :disabled="isDisabled" @click="onSubmitFrom('adapayForm',1)"> 提现 </el-button>
              <el-button  v-if="doCash === false" type="info" v-loading="loading" plain :disabled="isDisabled" @click="disableDoCash()"> 提现 </el-button>
            </el-form-item>
          </div>
        </el-form>
        <el-table :data="cashList" stripe border>
          <el-table-column prop="cash_type" label="提现类型" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="cash_amt" label="提现金额" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="status" label="提现状态" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="create" label="提现时间" align="center" show-overflow-tooltip></el-table-column>
        </el-table>
        <div class="content-padded content-center">
          <el-pagination
            small
            background
            layout="total, sizes, prev, pager, next, jumper"
            @current-change="handleCashCurrentChange"
            @size-change="handleCashSizeChange"
            :current-page.sync="cashParams.page"
            :total="cash_total_count"
            :pager-count="5"
            :page-size="cashParams.pageSize"
            :page-sizes="[10, 20, 50, 100]"
          >
          </el-pagination>
        </div>
      </div>
    </el-drawer>
    <el-drawer
      :title="dougongTitle"
      :visible.sync="dougongDialog"
      direction="rtl"
      size="580px"
    >
      <dougong-pay-config
        v-if="dougongDialog && currentDougongDealerId"
        :dealer-id="currentDougongDealerId"
        :dealer-name="currentDougongDealerName"
      />
    </el-drawer>
    <el-drawer
      title="分期配置"
      :visible.sync="stagingDialog"
      direction="rtl"
      size="580px"
    >
      <staging-config
        v-if="stagingDialog && stagingDetailData.dealer_id"
        :detail-data="stagingDetailData"
        @success="onStagingConfigSuccess"
      />
    </el-drawer>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { saveDealer, openDealer, getDealerList, getWxaDristributorCodeStream, setDefaultDistributor, saveOpen } from '@/api/marketing'
import { getTagList, distributorRelTags, getDistance, setDistance } from '@/api/marketing'
import { getDistributorMeiQia, setDistributorMeiQia } from '@/api/im'
import { getCodeUnlimit } from '@/api/wxa'
import district from '../../../../common/district.json'
import shopDecoration from '@/components/function/shopDecoration'
import pcDecoration from '@/view/pc/homePage/default'
import { getSetting } from '@/api/fenzhang'
import ImportDialog from '@/components/importDialog'
import DougongPayConfig from './dougong-pay-config'
import StagingConfig from './staging-config'
import store from '@/store'
import {getAdapayDetail, saveAdapayFrom, getAdaPayCashList,getAdaPayCapitalList} from '@/api/trade'
import { useDialog } from '@shopex/finder'
// 取选中地区的值
function getCascaderObj (val, opt) {
  return val.map(function (value, index, array) {
    for (var itm of opt) {
      if (itm.value === value) {
        opt = itm.children
        return itm
      }
    }
    return null
  })
}

export default {
  data () {
    return {
      isDisabled: true,
      inputDisabled: true,
      title:'',
      dialog: false,
      dougongDialog: false,
      dougongTitle: '',
      currentDougongDealerId: '',
      currentDougongDealerName: '',
      stagingDialog: false,
      stagingDetailData: {},
      formLabelWidth: '180px',
      adapayForm: {
        name: '',
        mer_name: '',
        dealer_id: '',
        app_id: '',
        api_key_live: '',
        rsa_private_key: '',
        rsa_public_key: '',
        auto_cash: false,
        cash_type: 'T1',
        acct_balance: '0.00',
        remained_amt: '',
        type:'offline'
      },
      adapayFormOnline: {
        name: '',
        mer_name: '',
        dealer_id: '',
        app_id: '',
        api_key_live: '',
        rsa_private_key: '',
        rsa_public_key: '',
        auto_cash: false,
        cash_type: 'T1',
        acct_balance: '0.00',
        remained_amt: '',
        type:'online'
      },
      adapayFormRes: {},
      adapayFormResOnline: {},
      cashTitle: '',
      cashDialog: false,
      cashParams: {
        page: 1,
        pageSize: 10,
      },
      cash_total_count: 0,
      doCash: false,
      cashList: [],

      capitalDialog: false,
      capitalTitle: '',
      capitalParams: {
        page: 1,
        pageSize: 10,
      },
      capitalList: [],
      capitalTotalCount: 0,
      capitalType: [
        { name: '全部', value: '' },
        { name: '出账', value: 'outcome' },
        { name: '入账', value: 'income' }
      ],
      rules: {
        dealer_id: [
          {required: true, message: '请检查经销商ID', trigger: 'blur'}
        ],
        app_id: [
          {required: true, message: '请输入 应用ID', trigger: 'blur'}
        ],
        api_key_live: [
          {required: true, message: '请输入 API_KEY', trigger: 'blur'}
        ],
        rsa_private_key: [
          {required: true, message: '请输入 商户RSA私钥', trigger: 'blur'}
        ],
        rsa_public_key: [
          {required: true, message: '请输入 AdaPay RSA公钥', trigger: 'blur'}
        ],
        auto_cash: [
          {required: false, message: '自动提现', trigger: 'blur'}
        ],
        cash_type: [
          {required: false, message: '提现类型', trigger: 'blur'}
        ],
        remained_amt: [
          {required: false, message: '预留金', trigger: 'blur'}
        ],
      },
      is_distributor: false,
      dialogVisible: false,
      exportloading: false,
      current: '', // 当前店铺id
      isValidList: [
        { name: '全部', value: '' },
        { name: '启用', value: 'true' },
        { name: '禁用', value: 'false' }
      ],
      paymentChannelList: [
        { name: '全部', value: '' },
        { name: 'AdaPay', value: 'adapay' },
        { name: '斗拱', value: 'dougong' }
      ],
      changeStatus: true,
      activeName: 'first',
      total_count: 0,
      distributor_self: '',
      detailDialog: false,
      pcDialogVisible: false,
      dialogTitle: '',
      select_tags_value: '',
      loading: false,
      amount: '',
      params: {
        page: 1,
        pageSize: 20,
        name: '',
        mobile: '',
        is_valid: '',
        province: '',
        city: '',
        area: '',
        dealer_hqid: '',
        distributor_hqid: '',
        distributor_vad: '',
        channel_rtm: '',
        payment_channel: ''
      },
      form: {
        dealer_id: null,
        mobile: '',
        address: '',
        name: '',
        is_valid: 'true',
        regions_id: [],
        regions: [],
        shop_id: 0,
        contact: '',
        is_distributor: 'true'
      },
      list: [],
      regions: district,
      codetype: 'index',
      rowdata: {},
      downDistributorVal: false,
      distributor_id: [],
      tag: {
        dialog: false,
        editItem: [],
        list: [],
        form: {
          tag_ids: [],
          dealer_id: []
        },
        currentTags: [],
        tags: []
      },
      validSwitchLoading: null,
      setMeiQiaVisible: false,
      setMeiQiaDialog: false,
      meiqia_form: {
        dealer_id: '',
        meiqia_id: '',
        meiqia_token: ''
      },
      setDistanceVisible: false,
      setDistanceDialog: false,
      distanceForm: {
        distance: ''
      },
      isOpen: false,
      operator_type: '',
      dealer_id: []
    }
  },
  components: { shopDecoration, pcDecoration, ImportDialog, DougongPayConfig, StagingConfig },
  computed: {
    ...mapGetters([
      'wheight',
      'wxapp_id',
      'template_name',
      'login_type'
    ])
  },
  methods: {
    handleChange(value, oldValue) {
      console.log(value);
    },
    getAdaPayCashSetting(row) {
      this.cashDialog = true;
      this.cashTitle = row.name + '的AdaPay提现配置及成功记录';
      this.adapayForm.dealer_id = row.dealer_id;
      this.cashParams.dealer_id = row.dealer_id;
      this.onGetDetail(row.dealer_id, row.name, 'cash');
      this.getCashList();
    },
    getAdapaySetting(row) {
      this.dialog = true;
      this.title = row.name + ' 的AdaPay支付配置';
      this.adapayForm.dealer_id = row.dealer_id;
      this.adapayFormOnline.dealer_id = row.dealer_id;
      this.onGetDetail(row.dealer_id, row.name, 'setting');
    },
    onGetDetail(dealer_id, name, type) {
      getAdapayDetail({dealer_id,type}).then(res => {
        let result = res.data.data
        this.adapayFormRes = result.OffLine;
        this.adapayFormResOnline = result.OnLine;

        this.adapayForm.name     = name;
        this.adapayForm.mer_name = result.OffLine.mer_name;

        this.adapayForm.app_id   = result.OffLine.app_id;
        this.adapayForm.api_key_live = result.OffLine.api_key_live;
        this.adapayForm.rsa_private_key = result.OffLine.rsa_private_key;
        this.adapayForm.rsa_public_key = result.OffLine.rsa_public_key;
        this.adapayForm.acct_balance = result.OffLine.acct_balance;


        //online
        this.adapayFormOnline.name     = name;
        this.adapayFormOnline.mer_name = result.OnLine.mer_name;

        this.adapayFormOnline.app_id   = result.OnLine.app_id;
        this.adapayFormOnline.api_key_live = result.OnLine.api_key_live;
        this.adapayFormOnline.rsa_private_key = result.OnLine.rsa_private_key;
        this.adapayFormOnline.rsa_public_key = result.OnLine.rsa_public_key;
        this.adapayFormOnline.acct_balance = result.OnLine.acct_balance;



        if (result.OnLine.acct_balance) {
          if (this.adapayForm.acct_balance > this.adapayForm.remained_amt) {
            this.isDisabled = false;
          }
        }
      })
    },
    onSubmitFrom(adapayForm, isCash = 0,sourcetype='offline') {
      if ( isCash ) { // 提现
        if (!this.adapayForm.app_id || !this.adapayForm.api_key_live || !this.adapayForm.rsa_private_key || !this.adapayForm.rsa_public_key) {
          this.isDisabled = true;
          this.title = '请检查' + this.adapayForm.name + '的AdaPay支付配置';
          this.$confirm(this.title, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.dialog = true;
          }).catch(() => {
          });

          return false;
        }

        if ( this.adapayForm.acct_balance) {// 确保账户里有钱
          if (this.adapayForm.acct_balance > this.adapayForm.remained_amt) {
            this.isDisabled = false;
          } else {
            this.isDisabled = true;
            this.$message.error('请确认账户金额，去除预留金后仍有足够的金额！');
            return false;
          }
        } else {
          this.$message.error('请确认账户里有足够的金额！');
          return false;
        }

      }
      this.$refs[adapayForm].validate(valid => {
        if (valid) {
          this.loading = true
          this.adapayForm.is_cash = isCash;
          var cash_amount = this.amount;
          if (!cash_amount || cash_amount === '') {
            cash_amount = adapayForm.acct_balance;
          }
          if(sourcetype === "online"){
            this.adapayForm = this.adapayFormOnline
          }
          this.adapayForm.amount = cash_amount;
          saveAdapayFrom(this.adapayForm).then(response => {
            let res = response.data, type = 'error', msg = '操作失败';
            console.log(res, '========');
            if (res) {
              type = 'success';
              msg = res.message ? res.message : '操作成功';
            }
            this.$message({
              type: type,
              message: msg,
              duration: 3 * 1000
            });
            this.getCashList();
          }).catch(error => {
            // this.$message.error('操作失败，请检查AdaPay支付配置或联系管理员');
          })
        }
        this.loading = false
      })
    },
    disableDoCash() {
      this.$message.error('请等待其他提现请求处理完成后再进行提现！')
    },
    handleCashCurrentChange(page_num) {
      this.cashParams.page = page_num;
      this.getCashList();
    },
    handleCashSizeChange (pageSize) {
      this.cashParams.page = 1
      this.cashParams.pageSize = pageSize
      this.getCashList();
    },
    getCashList(){
      getAdaPayCashList(this.cashParams).then((response) => {
        if (response.data.data.list) {
          this.cashList = response.data.data.list
          this.doCash = response.data.data.doCash
          this.cash_total_count = response.data.data.total_count
        }
      });
    },

    exportData () {
      this.exportloading = true
      getDealerList({...this.params,is_export:true, dealer_id: this.dealer_id}).then(res => {
        this.exportloading = false
        if (res.data.data.status) {
          this.$message({
            type: 'success',
            message: '已加入执行队列，请在设置-导出列表中下载'
          })
          return
        } else if (res.data.data.url) {
          this.downloadUrl = res.data.data.url
          this.downloadName = res.data.data.filename
          this.downloadView = true
        } else {
          this.$message({
            type: 'error',
            message: '无内容可导出 或 执行失败，请检查重试'
          })
          return
        }
      }).catch(error => {
        this.exportloading = false
      })
    },
    linkTemplates (distributor) {
      const { distributor_id, address, name } = distributor
      this.$store.dispatch('setTemplateName', 'yykweishop')
      this.$router.push({
        path: this.matchHidePage('template'),
        query: { distributor_id, address, name }
      })
    },
    async downQrCode (way, row) {
      let isNomo = row.channel_rtm.toUpperCase() === 'MONO'
      let params = {
        wxaAppId: this.wxapp_id,
        way,
        source_type: 'dealer_hqid',
        dealer_hqid: isNomo ? row.distributor_hqid : row.dealer_hqid
      }
      const res = await getCodeUnlimit(params)
      const elemt = document.createElement('a')
      elemt.href = res.data.data.base64Image
      elemt.download = `${row.name}_${row.dealer_hqid}_平台首页.png`
      elemt.click()
    },
    dialogShow (id, type) {
      this.current = id
      type === 'pc' ? (this.pcDialogVisible = true) : (this.dialogVisible = true)
    },
    closeDialog () {
      this.dialogVisible = false
      this.pcDialogVisible = false
    },
    isValidSelectHandle () {
      this.params.page = 1
      this.getList()
    },
    paymentChannelSelectHandle () {
      this.params.page = 1
      this.getList()
    },
    numberSearch (e) {
      this.params.page = 1
      this.getList()
    },
    handleCurrentChange (page_num) {
      this.params.page = page_num
      this.getList()
    },

    handleDistance () {
      this.distanceForm.distance = ''
      // this.resetInfo();
      // this.operate = "create";
      // this.dialogVisible = true;
    },
    addDistributorSelf () {
      this.$router.push({ path: this.matchHidePage('editor') })
    },
    editDistributorSelf () {
      this.$router.push({ path: this.matchHidePage('editor'), query: { distributor_type: 'distributor_self', distributor_id: this.distributor_self } })
    },
    getList () {
      this.loading = true
      getDealerList(this.params).then((response) => {
        if (response.data.data.list) {
          this.list = response.data.data.list
          this.total_count = response.data.data.total_count
          this.distributor_self = response.data.data.distributor_self
        }
        this.loading = false
      })
    },
    downDistributorCode (row, template_name) {
      let params = { distributor_id: row.distributor_id, codetype: this.codetype }
      if (template_name) {
        params.template_name = template_name
      }
      getWxaDristributorCodeStream(params).then((response) => {
        var a = document.createElement('a')
        var temp = '微商城'
        a.href = response.data.data.base64Image
        if (response.data.data.tempname) {
          var temp = response.data.data.tempname
        }
        a.download = temp + row.name + '.png'
        a.click()
      })
    },
    RegionChangeSearch (value) {
      var vals = getCascaderObj(value, this.regions)
      if (vals.length == 1) {
        this.params.province = vals[0].label
        this.params.city = ''
        this.params.area = ''
      } else if (vals.length == 2) {
        this.params.province = vals[0].label
        this.params.city = vals[1].label
        this.params.area = ''
      } else if (vals.length == 3) {
        this.params.province = vals[0].label
        this.params.city = vals[1].label
        this.params.area = vals[2].label
      }
      this.params.page = 1
      this.getList()
    },
    TagChangeAction (value) {
      this.params.tag_id = value
      this.params.page = 1
      this.getList()
    },
    downDistributor (row, codetype) {
      this.codetype = codetype
      this.rowdata = row
      this.downDistributorVal = true
    },
    defaultSwitchChange (row) {
      var params = {
        distributor_id: row.distributor_id
      }
      setDefaultDistributor(params).then((response) => {
        if (response.data.data.status) {
          for (var i = this.list.length - 1; i >= 0; i--) {
            if (this.list[i].distributor_id != row.distributor_id) {
              this.list[i].is_default = false
            }
          }
        }
      })
    },
    switchChangeAuditGoods (index, row) {
      var params = {
        distributor_id: row.distributor_id,
        is_audit_goods: row.is_audit_goods
      }
      saveDistributor(params).then((response) => {
        this.detailDialog = false
        this.getList()
        this.$message({
          type: 'success',
          message: '保存成功'
        })
      })
    },
    switchChangeAutoSyncGoods (index, row) {
      var params = {
        distributor_id: row.distributor_id,
        auto_sync_goods: row.auto_sync_goods
      }
      saveDistributor(params).then((response) => {
        this.detailDialog = false
        this.getList()
        this.$message({
          type: 'success',
          message: '保存成功'
        })
      })
    },
    switchChangeOpen (index, row) {
      var params = {
        distributor_id: row.distributor_id,
        is_open: row.is_open
      }
      saveOpen(params).then((response) => {
        this.detailDialog = false
        this.getList()
        this.$message({
          type: 'success',
          message: '保存成功'
        })
      })
    },
    switchChange (index, row) {
      var params = {
        distributor_id: row.distributor_id,
        is_ziti: row.is_ziti,
        is_delivery: row.is_delivery
      }
      saveDistributor(params).then((response) => {
        this.detailDialog = false
        this.getList()
        this.$message({
          type: 'success',
          message: '保存成功'
        })
      })
    },
    handleSelectionChange (val) {
      let distributor_id = []
      for (let i in val) {
        distributor_id.push(val[i].distributor_id)
      }
      this.distributor_id = distributor_id
      this.dealer_id = val.map(item => item.dealer_id)
    },
    getAllTagList () {
      let params = {
        page: 1,
        pageSize: 500
      }
      getTagList(params).then((response) => {
        this.tag.list = response.data.data.list
      })
    },
    handleCancelLabelsDialog () {
      this.tag.dialog = false
    },
    tagUpdate (row) {
      this.tag.editItem = [row.itemName]
      this.tag.currentTags = row.tagList || []
      this.tag.form.distributor_id = row.distributor_id
      this.showTags()
    },
    addDistributorTag () {
      this.tag.currentTags = []
      if (this.distributor_id.length) {
        this.showTags()
        this.tag.form.distributor_id = this.distributor_id
      } else {
        this.$message({
          type: 'error',
          message: '请选择至少一个店铺!'
        })
      }
    },
    showTags () {
      this.tag.tags = [...this.tag.list]
      this.tag.tags.forEach((item, index) => {
        let isInArr = this.tag.currentTags.findIndex((n) => n.tag_id == item.tag_id)
        if (isInArr != -1) this.tag.tags.splice(index, 1)
      })
      this.tag.dialog = true
    },
    tagRemove (index) {
      this.tag.tags.unshift(this.tag.currentTags[index])
      this.tag.currentTags.splice(index, 1)
    },
    tagAdd (item, index) {
      let isInArr = this.tag.currentTags.findIndex((n) => n.tag_id == item.tag_id)
      if (isInArr == -1) {
        this.tag.currentTags.push(item)
        this.tag.tags.splice(index, 1)
      }
    },
    submitItemTag () {
      this.tag.form.tag_ids = []
      this.tag.currentTags.forEach((item) => {
        this.tag.form.tag_ids.push(item.tag_id)
      })
      if (this.tag.form.tag_ids.length <= 0) {
        this.$message({
          type: 'error',
          message: '请选择店铺标签'
        })
        return false
      }
      this.tag.dialog = false
      distributorRelTags(this.tag.form).then((res) => {
        if (res.data.data.status) {
          this.$message({
            type: 'success',
            message: '打标签完成'
          })
        }
      })
    },
    tagSearchUserChange () {
      this.currentPage = 1
      this.getParams()
      this.getItemsList(this.params)
      this.loading = false
    },
    onValidSwitchChange (row, checked) {
      const newVal = checked ? 'true' : 'false'
      const oldVal = row.is_valid
      if (newVal === oldVal) return
      const msg = newVal === 'true' ? '确定开启该经销商？' : '确定禁用该经销商？'
      this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.validSwitchLoading = row.dealer_id
          return openDealer({
            dealer_id: row.dealer_id,
            is_valid: newVal
          })
        })
        .then(() => {
          row.is_valid = newVal
          this.$message.success('状态已更新')
        })
        .catch((action) => {
          if (action === 'cancel' || action === 'close') {
            this.$message.info('已取消')
          }
        })
        .finally(() => {
          this.validSwitchLoading = null
        })
    },
    showSettingMeiQia (distributor_id) { // 设置美洽参数
      this.setMeiQiaVisible = true
      let that = this
      getDistributorMeiQia(distributor_id).then(response => {
        that.meiqia_form.meiqia_id = response.data.data.meiqia_id
        that.meiqia_form.meiqia_token = response.data.data.meiqia_token
      })
      that.meiqia_form.distributor_id = distributor_id
      console.log(this.meiqia_form)
    },
    handleMeiQiaCancel () { // 美洽设置窗口关闭
      this.setMeiQiaVisible = false
      this.meiqia_form.distributor_id = ''
      this.meiqia_form.meiqia_id = ''
      this.meiqia_form.meiqia_token = ''
    },
    handleSubmitMeiQia () { // 提交美洽配置
      let params = {
        meiqia_id: this.meiqia_form.meiqia_id,
        meiqia_token: this.meiqia_form.meiqia_token
      }
      setDistributorMeiQia(this.meiqia_form.distributor_id, params).then(response => {
        this.$message({
          type: 'success',
          message: '已提交'
        })
        this.handleMeiQiaCancel()
      })
    },
    showSettingDistance () { // 设置距离参数
      this.setDistanceVisible = true
      let that = this
      getDistance().then(response => {
        that.distanceForm.distance = response.data.data.distance
      })
      console.log(this.distanceForm)
    },
    handleDistanceCancel () { // 距离设置窗口关闭
      this.setDistanceVisible = false
      this.distanceForm.distance = ''
    },
    handleSubmitDistance () { // 提交距离配置
      let params = {
        distance: this.distanceForm.distance
      }
      setDistance(params).then(response => {
        this.$message({
          type: 'success',
          message: '提交成功'
        })
        this.handleDistanceCancel()
      })
    },
    handleSizeChange (pageSize) {
      this.params.page = 1
      this.params.pageSize = pageSize
      this.getList()
    },
    onCopy () {
      this.$notify.success({
        message: '复制成功',
        showClose: true
      })
    },
    openPaymentChannelConfig (row) {
      const {
        dealer_id,
        name,
        dealer_hqid,
        payment_channel,
        auto_split_days,
        account_validity_days
      } = row
      useDialog(null, {
        title: '经销商支付通道配置',
        width: '520px',
        detailData: {
          dealer_id,
          name,
          dealer_hqid,
          payment_channel: payment_channel || 'adapay',
          auto_split_days,
          account_validity_days
        },
        component: () => import('./payment-channel-config.vue'),
        actions: [
          { label: '取消', key: 'close', size: 'default' },
          { label: '确定', key: 'save', type: 'primary', size: 'default' }
        ]
      }).then(refresh => {
        if (refresh) this.getList()
      })
    },
    openSplitConfig (row) {
      const {
        dealer_id,
        name,
        dealer_hqid,
        payment_channel,
        account_validity_days
      } = row
      useDialog(null, {
        title: '分账配置',
        width: '560px',
        detailData: {
          dealer_id,
          name,
          dealer_hqid,
          payment_channel: payment_channel || 'adapay',
          account_validity_days
        },
        component: () => import('./split-config.vue'),
        actions: [
          { label: '取消', key: 'close', size: 'default' },
          { label: '确定', key: 'save', type: 'primary', size: 'default' }
        ]
      }).then(refresh => {
        if (refresh) this.getList()
      })
    },
    openDougongSetting (row) {
      this.dougongDialog = true
      this.dougongTitle = row.name + ' - 斗拱支付配置'
      this.currentDougongDealerId = row.dealer_id
      this.currentDougongDealerName = row.name
    },
    /** 分期配置 */
    handleStagingConfig (row) {
      const {
        dealer_id,
        name,
        dealer_hqid,
        open_fq_pay_hua_bei,
        open_fq_pay_credit_card,
        fq_pay_min_price
      } = row
      this.stagingDetailData = {
        dealer_id,
        name,
        dealer_hqid,
        open_fq_pay_hua_bei,
        open_fq_pay_credit_card,
        fq_pay_min_price
      }
      this.stagingDialog = true
    },
    onStagingConfigSuccess () {
      this.stagingDialog = false
      this.getList()
    }
  },

  mounted () {
    if (store.getters.login_type === 'distributor') {
      this.is_distributor = true
    }
    this.getList()
    this.getAllTagList()
    getSetting().then(res => {
      let data = res.data.data
      this.isOpen = data.is_open == 'true'
    })
    this.operator_type = store.getters.login_type
  },
  beforeRouteUpdate (to, from, next) {
    next()
    if (to.path.indexOf('_editor') === -1 && to.path.indexOf('_detail') === -1) {
      this.getList()
      this.getAllTagList()
    }
  },
}
</script>
